"use strict";
// @ts-nocheck
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importDefault(require("react"));
var DecoratedLink = function (props) {
    var contentState = props.contentState, entityKey = props.entityKey, children = props.children, editLinkFn = props.editLinkFn;
    var url = contentState.getEntity(entityKey).getData().url;
    return (react_1["default"].createElement("a", { href: url, onClick: function () { return editLinkFn(contentState, entityKey, children); } }, children));
};
DecoratedLink.propTypes = {
    entityKey: prop_types_1["default"].string.isRequired,
    contentState: prop_types_1["default"].object.isRequired,
    editLinkFn: prop_types_1["default"].func.isRequired,
    children: prop_types_1["default"].array
};
DecoratedLink.defaultProps = {
    children: []
};
exports["default"] = DecoratedLink;
